

export const APP_PROMO_DESCRIPTION = 'Beatmatch is the social events platform for music, art, and culture. We empower people create events, discover experiences, and build community in real life. Join Beatmatch so you can do more together!';